import React from "react";
import { Layout } from "antd";
import HeaderContent from "./HeaderContent";
import SiderContent from "./SiderContent";

const { Content } = Layout;

const LayoutContainer = ({ children }) => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <HeaderContent />
      <Layout style={{ marginTop: 48 }}>
        <SiderContent />
        <Layout style={{ marginLeft: 200, padding: "24px", background: "#fff" }}>
          <Content>{children}</Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default LayoutContainer;
